import { Component, Input } from '@angular/core';

@Component({
  selector: 'user-tag',
  templateUrl: 'user-tag.html',
})
export class UserTagComponent {
  @Input()
  user;

  @Input()
  prepend = '';

  @Input()
  append = '';

  @Input()
  colored = true;

  tagBackgrounds = {
    cdlHolder: 'yellow',
    ownerOperator: 'green-popup',
    ownAuthority: 'orange',
    moderator: 'primary',
  };

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/user-tag/user-tag.ts